import { useInfiniteQuery } from 'react-query'
import { useDispatch, useSelector } from 'react-redux'
import { enqueueSnackbar } from '../../root/actions'
import { getSagasMsgs } from '../../root/selectors'
import { getTomPicturesRequest } from '../api/tomApi'
import { take } from '../utils/constants'
import { isLastPage } from '../utils/isLastPage'

export const useDevicePictures = (device_id, filters) => {
    const dispatch = useDispatch()
    const sagasMsgs = useSelector(getSagasMsgs)

    return useInfiniteQuery(
        [`devicePictures-${device_id}`, filters],
        ({ pageParam = 0 }) =>
            getTomPicturesRequest({
                device_id,
                take,
                skip: pageParam,
                with_report_types: 1,
                ...filters
            }),
        {
            getNextPageParam: lastPage => isLastPage(lastPage, take),
            onError: e =>
                dispatch(
                    enqueueSnackbar({
                        message: sagasMsgs.getTomPicturesEx,
                        options: {
                            variant: 'error'
                        }
                    })
                ),
            refetchOnWindowFocus: false
        }
    )
}
